module.exports = __webpack_public_path__ + "img/early_02.68f3a81f.png";